// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"90dc4b30","513":"1569076a","703":"c538516a","787":"a29438fc"}[chunkId] + ".chunk.js";
};